import { atom, action } from "@reatom/framework";

export const openedModalAtom = atom<string | null>(null, "openedModalAtom");
export const toggleModal = action((ctx, view: string | null) => {
  openedModalAtom(ctx, view);
}, "toggleModal");
